import Backbone from 'backbone'
import UserView from './user'
import _ from 'underscore'
import UserReportingViewTemplate from '../templates/user-reporting.tpl'
import config from '../config'

const UserReportingView = UserView.extend({
    events: {
        'click': 'loadStudentResults',
    },
    initialize() {
        this.template = _.template(UserReportingViewTemplate)
    },
    loadStudentResults(event) {
        event.stopPropagation()
        const slug = config.get('slug')
        const classId = this.model.get('class').get('id')
        const userId = this.model.get('id')
        Backbone.history.navigate(`app/${slug}/reporting/${classId}/${userId}`, { trigger: true })
    }
})

export default UserReportingView